export default __webpack_public_path__ + "static/media/MilkTeaPouring5.1ef4c6fa.jpg";